import { useLayoutEffect, useRef, type ReactNode } from 'react';

/**
 * Wraps bottom chrome (e.g. a floating tab bar) that should step aside while
 * the on-screen keyboard is up. Its measured height feeds `.kb-collapse`
 * (index.css), which animates a matching negative margin in step with the
 * keyboard, so content above glides down into the freed space in one motion.
 */
export function KeyboardCollapse({ className = '', children }: { className?: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => el.style.setProperty('--collapse-h', `${el.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`kb-collapse ${className}`}>
      {children}
    </div>
  );
}

export default KeyboardCollapse;
